<div class="blackout-group-picker" data-testid="blackout-group-picker">

  <div class="blackout-picker-filters">
    <div class="field">
      <label class="label is-small">Find a group</label>
      <input
        class="input is-small"
        type="text"
        [disabled]="disabled"
        [(ngModel)]="searchText"
        placeholder="Search by name or timezone"
        data-testid="blackout-picker-search"
      />
    </div>
    <div class="field">
      <label class="label is-small">Scope</label>
      <div class="select is-small">
        <select
          [disabled]="disabled"
          [(ngModel)]="scopeFilter"
          data-testid="blackout-picker-scope"
        >
          <option *ngFor="let filter of SCOPE_FILTERS" [ngValue]="filter.value">{{ filter.label }}</option>
        </select>
      </div>
    </div>
    <button
      type="button"
      class="button is-small is-text blackout-picker-clear"
      *ngIf="isFiltered"
      (click)="clearFilters()"
      data-testid="blackout-picker-clear-filters"
    >Clear filters</button>
  </div>

  <p class="blackout-picker-hint">
    Check every group that applies to this scoring window. Their rules are combined —
    scoring is blocked whenever any checked group blocks it.
  </p>

  <p class="blackout-picker-hidden-note" *ngIf="hiddenSelectedGroups.length" data-testid="blackout-picker-selection-hidden">
    {{ hiddenSelectedGroups.length }} checked group{{ hiddenSelectedGroups.length === 1 ? '' : 's' }}
    hidden by the current filters: <strong>{{ hiddenSelectedSummary }}</strong>.
  </p>

  <div class="blackout-picker-list">

    <button
      type="button"
      class="blackout-picker-row"
      [class.is-selected]="isOffSelected"
      [disabled]="disabled"
      (click)="selectOff()"
      data-testid="blackout-picker-off"
    >
      <span class="blackout-picker-row-main">
        <span class="blackout-picker-row-title">Off — scoring available at all times</span>
        <span class="blackout-picker-row-meta">Clears every group; no non-working hours are enforced for this scoring window.</span>
      </span>
    </button>

    <div
      class="blackout-picker-row is-checkable"
      *ngFor="let group of filteredGroups; trackBy: trackById"
      [class.is-selected]="isSelected(group.id)"
      [class.is-editing]="isEditing(group.id)"
      [class.is-disabled-row]="disabled"
      role="checkbox"
      [attr.aria-checked]="isSelected(group.id)"
      [attr.tabindex]="disabled ? -1 : 0"
      (click)="onGroupRowClick(group.id)"
      (keyup.enter)="onGroupRowClick(group.id)"
      (keyup.space)="onGroupRowClick(group.id); $event.preventDefault()"
      [attr.data-testid]="'blackout-picker-group-' + group.id"
    >
      <input
        class="blackout-picker-checkbox"
        type="checkbox"
        [disabled]="disabled"
        [checked]="isSelected(group.id)"
        (click)="$event.stopPropagation()"
        (change)="toggleGroup(group.id)"
        [attr.aria-label]="'Apply ' + group.name + ' to this scoring window'"
        [attr.data-testid]="'blackout-picker-checkbox-' + group.id"
      />
      <span class="blackout-picker-row-main">
        <span class="blackout-picker-row-title">
          {{ group.name }}
          <span class="tag is-small is-info is-light" *ngIf="isActive(group)">In use here</span>
          <span class="tag is-small is-link is-light" *ngIf="isEditing(group.id)">Editing rules</span>
          <span
            class="tag is-small is-warning is-light"
            *ngIf="otherWindows(group).length"
            [attr.title]="otherWindowsSummary(group)"
          >Shared · {{ otherWindows(group).length }}</span>
        </span>
        <span class="blackout-picker-row-meta">
          <span *ngIf="group.academic_year">{{ group.academic_year }} · </span>{{ group.timezone }} · {{ ruleCount(group) }} rule{{ ruleCount(group) === 1 ? '' : 's' }}
        </span>
        <span class="blackout-picker-row-meta" *ngIf="otherWindows(group).length">
          Also used by {{ otherWindowsSummary(group) }}
        </span>
      </span>
      <button
        type="button"
        class="button is-small is-text blackout-picker-edit"
        *ngIf="isSelected(group.id) && !isEditing(group.id)"
        [disabled]="disabled"
        (click)="onEditGroupClick(group.id, $event)"
        [attr.data-testid]="'blackout-picker-edit-' + group.id"
      >Edit rules</button>
    </div>

    <div class="notification is-light is-size-7" *ngIf="!filteredGroups.length" data-testid="blackout-picker-empty">
      <span *ngIf="isFiltered">No groups match the current filters.</span>
      <span *ngIf="!isFiltered">No non-working hour groups exist yet.</span>
    </div>

    <button
      type="button"
      class="blackout-picker-row is-create"
      *ngIf="allowCreate"
      [class.is-selected]="isCreatingGroup"
      [disabled]="disabled"
      (click)="selectNewGroup()"
      data-testid="blackout-picker-new-group"
    >
      <span class="blackout-picker-row-main">
        <span class="blackout-picker-row-title">+ Create a new group</span>
        <span class="blackout-picker-row-meta">Define rules below, then apply them to this scoring window.</span>
      </span>
    </button>

  </div>
</div>
